export const faqs = [
  {
    question: "How much does Rinnai air conditioning cost in Perth?",
    answer: "The installed cost depends on the system type, capacity, home layout, electrical requirements, access and, for ducted systems, the number of zones and outlets. A home-specific quote is more reliable than comparing unit-only prices online.",
  },
  {
    question: "Should I choose ducted, split or multi-split air conditioning?",
    answer: "A split system usually suits one main room. Multi-split can serve several rooms from one outdoor unit. Ducted is generally the strongest starting point for discreet whole-home comfort. The right choice depends on how many rooms you use, your budget and the property itself.",
  },
  {
    question: "Can you replace my existing air conditioner with a Rinnai system?",
    answer: "Yes, replacement enquiries are welcome. The existing unit, pipework, ductwork, electrical supply, controls and access should be assessed before confirming what can be retained and what should be upgraded.",
  },
  {
    question: "Do Rinnai systems heat as well as cool?",
    answer: "Applicable Rinnai reverse-cycle systems provide both heating and cooling. Product capability varies by model, so the quoted system should be checked against your year-round comfort needs.",
  },
  {
    question: "Can I control rooms separately or use my phone?",
    answer: "Compatible controls can provide zoning, schedules, remote access and other smart features on applicable systems. Availability depends on the selected product and how the system is configured.",
  },
  {
    question: "Are your air-conditioning installers licensed?",
    answer: "Perth Home Air Conditioning states that its air-conditioning installers are ARC Tick licensed. The team provides residential supply and installation services, with removal requirements confirmed as part of the individual quote.",
  },
  {
    question: "How much local experience does Perth Home Air Conditioning have?",
    answer: "Perth Home Air Conditioning states that it has served the Perth metropolitan area for more than 30 years, supported by the established air-conditioning experience of sister company Langler Air.",
  },
  {
    question: "Do you install across Perth?",
    answer: "Perth Home Air Conditioning provides residential supply and installation across metropolitan Perth. Share your suburb or postcode in the quote form so the team can confirm service availability for your address.",
  },
];
